module.exports = __webpack_public_path__ + "img/flowEpc.c57876fd.svg";